import React, { Component } from "react";
import Header from "./header";
import MenuBar from "./navbar";
import SocialMediaLinks from "./socialmedialinks";
import { BASE_URL } from "./utility";
import { Card, Button, Container, Row, Col } from "react-bootstrap";

class Brochures extends Component {
  constructor() {
    super();
    this.state = {
      cardData: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      const response = await fetch(BASE_URL + "filenames/pdfs");
      const pdfFiles = await response.json();

      const cardData = pdfFiles.map((file) => {
        // Remove file extension and make title readable
        const baseName = file.replace(/\.[^/.]+$/, "");
        const formattedTitle = baseName
          .replace(/[-_]/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase());

        return {
          imgSrc: `${BASE_URL}download/pdfthumbs/${file}`,
          title: formattedTitle,
          text: `${formattedTitle} brochure`,
          pdfLink: `${BASE_URL}download/pdfs/${baseName}.pdf`,
        };
      });

      this.setState({ cardData });
    } catch (err) {
      console.error("Error fetching brochures:", err);
    }
  };

  render() {
    return (
      <div
        style={{ backgroundImage: `url(${BASE_URL + "download/general/bg"})` }}
      >
        <Header />
        <MenuBar />

        <Container style={{ marginTop: "2rem" }}>
          <h2 className="text-center text-white mb-5">Brochures</h2>

          <Row className="g-4">
            {" "}
            {/* g-4 adds horizontal & vertical gaps */}
            {this.state.cardData.map((card, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3}>
                <Card
                  className="h-100 shadow-sm"
                  style={{
                    borderRadius: "15px",
                    transition: "transform 0.3s",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <Card.Img
                    variant="top"
                    src={card.imgSrc}
                    style={{
                      height: "150px",
                      objectFit: "cover",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    }}
                  />
                  <Card.Body className="d-flex flex-column">
                    <Card.Title
                      style={{ fontSize: "1rem", marginBottom: "0.5rem" }}
                    >
                      {card.title}
                    </Card.Title>
                    <Card.Text style={{ fontSize: "0.9rem", flexGrow: 1 }}>
                      {card.text}
                    </Card.Text>
                    <Button
                      variant="primary"
                      href={card.pdfLink}
                      target="_blank"
                    >
                      View PDF
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>

        <div className="mt-5 pt-4">
          <SocialMediaLinks />
        </div>
      </div>
    );
  }
}

export default Brochures;
